
import { Record } from 'immutable'
const BookPlayer = Record({
  book_id:null,
  name:null
});
export default BookPlayer;
